import { initSentry } from './bootstrap/sentryInit';
import {
  isNewWidgetOnly,
  redirectLegacyWidgetCancelUrlIfNeeded,
  redirectWidgetCancelToManageIfNeeded
} from './utils/widget-entry.util';

initSentry();

if (redirectLegacyWidgetCancelUrlIfNeeded() || redirectWidgetCancelToManageIfNeeded()) {
  // Redirect in progress; do not mount any app tree on old cancellation/manage links.
} else if (isNewWidgetOnly()) {
  import('./bootstrap/NewWidgetRoot').then(m => {
    m.mountNewWidgetRoot();
  });
} else {
  import('./bootstrap/FullAppRoot').then(m => {
    m.mountFullAppRoot();
  });
}
